import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchModuleUpdate = createAsyncThunk(
    'moduleUpdate/fetchModuleUpdate',
    async ({ id, file, filesLang, filesTitle, showcaseID, pageId, title, slug, description, content, specialField1, filesToKeep }) => {
        const response = await ModuleUpdateService(id, file, filesLang, filesTitle, showcaseID, pageId, title, slug, description, content, specialField1, filesToKeep)
        console.log(response)
        console.log(file)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const moduleUpdateSlice = createSlice({
    name: 'moduleUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleUpdateSlice.reducer;
